export const DASHBOARD = "/";
export const LOGIN = "/login";
export const SIGN_UP = "/signup";
export const PROFILE = "/p/:username";
export const MESSAGES = "/p/:username/messages";
export const NOT_FOUND = "/not-found";
